import { useTranslation } from 'react-i18next';

import { sizeSixVariants } from '~/domain/sizes';

function isSelectedSize(selectedSize: string | undefined, size: string) {
  if (!selectedSize) return false;

  if (selectedSize === '6') return sizeSixVariants.some((s) => s === size);

  return selectedSize === size;
}

type Props = {
  selectedSize?: string;
  sizes: string[];
};

function Size({
  isHighlighted,
  children
}: {
  children: string;
  isHighlighted: boolean;
}) {
  return (
    <li
      className={`h-5 rounded-[40px] border border-grey-divide px-2 ${
        isHighlighted ? 'bg-black text-white' : 'bg-white text-grey-hide'
      }`}
    >
      {children}
    </li>
  );
}

function AffiliateSizes({ sizes, selectedSize }: Props) {
  const { t } = useTranslation('pdp');

  if (!sizes.length) return null;

  return (
    <ul className="flex	flex-wrap gap-1 text-xs" data-cy="stock-listing-sizes">
      <li className="text-grey-hide">{t('sizesInStock')}</li>
      {sizes.map((size) => (
        <Size
          key={`sl-size-${size}`}
          isHighlighted={isSelectedSize(selectedSize, size)}
        >
          {size}
        </Size>
      ))}
    </ul>
  );
}

export default AffiliateSizes;
